export default "__VITE_ASSET__BvGQq1Ae__"